import * as db from '../../db'
import _ from 'lodash'

export const RECEIVE_ACTIVE_PROJECTS = 'RECEIVE_ACTIVE_PROJECTS'
export const RECEIVE_DELETED_PROJECTS = 'RECEIVE_DELETED_PROJECTS'
export const LOADING_PROJECTS = 'LOADING_PROJECTS'
export const SELECT_PROJECT = 'SELECT_PROJECT'
export const PROJECT_BUNDLES = 'PROJECT_BUNDLES'
export const GET_PROJECT_PRODUCT_CATEGORIES = "GET_PROJECT_PRODUCT_CATEGORIES"
export const PROJECT_CATEGORY_WITH_SUB = "PROJECT_CATEGORY_WITH_SUB"

// initial state
const state = {
  loading: false,
  projects: {},
  deleted: {},
  selectedProject: undefined,
  projectCategories: undefined,
  projectBundles:[],
  categoryWithSubCategory:[]

}

// getters
const getters = {
  projects: state => _.values(state.projects),
  projectCategories: state => (state.projectCategories),
  deleted: state => _.values(state.deleted),
  loading: state => state.loading,
  selectedProject: state => state.projects[state.selectedProject],
  projectBundles:state => state.projectBundles,
  categoryWithSubCategory:state => state.categoryWithSubCategory
}

// actions
const actions = {
  findAll ({ commit }) {
    commit(LOADING_PROJECTS, true)
    db.projects.onSnapshot(function (snapshot) {
      let projects = {}
      snapshot.forEach(doc => {
        let project = doc.data()
        project.id = doc.id
        project.tax = project.tax || { rate: 0 }
        projects[project.id] = project
      })
      const activeProjects = _.pickBy(projects, function (project) {
        return !project.deleted
      })
      const deletedProjects = _.pickBy(projects, function (project) {
        return project.deleted
      })
      commit(RECEIVE_ACTIVE_PROJECTS, { activeProjects })
      commit(RECEIVE_DELETED_PROJECTS, { deletedProjects })
    })
    commit(LOADING_PROJECTS, false)
    // console.log("TCL: findAll -> LOADING_PROJECTS", LOADING_PROJECTS)

  },
  subCategoryFunc({commit},payload ){
    var id = payload
    db.categoryWithSubCategory.doc(id).get().then((doc)=>{
      if(doc.exists) {
        commit(PROJECT_CATEGORY_WITH_SUB, doc.data())
        console.log('shhrffhf', id)
      }
      else{
        console.log('nooooooooooooo' ,id)
      }
    })
  },
  getProjectCategories ({ state, dispatch, getters, commit }) {
    commit(PROJECT_CATEGORY_WITH_SUB, [])
    if(getters.selectedProject.categoryWithSubCategory){
           dispatch('subCategoryFunc',getters.selectedProject.categoryWithSubCategory )
    }

    if (getters.selectedProject.categories){
      let projectCategories = getters.selectedProject.categories
      commit(GET_PROJECT_PRODUCT_CATEGORIES, projectCategories )
    } else {
      let projectCategories = ["A/V", "LIGHTING CONTROL", "LIGHTING FIXTURES", "SHADES", "HVAC", "CAMERAS", "NETWORKING", "DECORATION"]
      commit(GET_PROJECT_PRODUCT_CATEGORIES, projectCategories )
    }
  },
  // checks state.projects for a project with matching fUrl. Grabs project.id and commits to SELECT_PROJECT
  // when a url is entered it will pull the friendly url (fUrl) and associate it to a project.
  findByFurl ({ commit, dispatch, state }, fUrl) {
    commit(LOADING_PROJECTS, true)
    let foundProject = _.filter(state.projects, { fUrl: fUrl })
    let selectedProject = foundProject[0].id
    commit(SELECT_PROJECT, selectedProject)
    dispatch('projectsBundles', selectedProject)
    commit(LOADING_PROJECTS, false)
  },

  selectProject ({ commit,dispatch }, selectedProject) {
    commit(SELECT_PROJECT, selectedProject)
    dispatch('projectsBundles', selectedProject)
  },
  projectsBundles({commit,state}, payload){
    const id =state.projects[payload].projectBundles
    if (id === undefined) {
        commit(PROJECT_BUNDLES,[])
    }
    else {

      db.projectbundles.doc(id).get().then((querySnapshot)=>{
        commit(PROJECT_BUNDLES,querySnapshot.data().projectBundles)
      })
    }

  }
}

// mutations
const mutations = {
  [RECEIVE_ACTIVE_PROJECTS] (state, { activeProjects }) {
    state.projects = activeProjects
  },
  [PROJECT_BUNDLES] (state,  projectBundles) {
    state.projectBundles = projectBundles
  },
  [PROJECT_CATEGORY_WITH_SUB] (state,  categoryWithSubCategory) {
    state.categoryWithSubCategory = categoryWithSubCategory
  },
  [GET_PROJECT_PRODUCT_CATEGORIES] (state, projectCategories){
    state.projectCategories = projectCategories
  },

  [RECEIVE_DELETED_PROJECTS] (state, { deletedProjects }) {
    state.deleted = deletedProjects
  },

  [SELECT_PROJECT] (state, selectedProject) {
    state.selectedProject = selectedProject
  },

  [LOADING_PROJECTS] (state, value) {
    state.loading = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/project.js